import { Pipe, PipeTransform } from '@angular/core';

import { ContactType } from '../models';

@Pipe({
  name: 'referrerArrangementHidden'
})
export class ReferrerArrangementHiddenPipe implements PipeTransform {
  /**
   * Determines if the Referrer Arrangement section should be hidden
   * based on the contact type.
   * 
   * @param contactType The contact type value
   * @returns true if referrer arrangement should be hidden, false otherwise
   */
  transform(contactType: ContactType | null): boolean {
    return contactType !== ContactType.Referrer;
  }
}

